module.exports = __webpack_public_path__ + "assets/img/13_369.360d6c7b.jpg";